import useFilterVisible from '../hooks/useFilterVisible';

const OpenFilter = ({ render, ...props }) => {
  const { onOpen } = useFilterVisible();
  return render({ openFilter: onOpen, ...props });
};

export default OpenFilter;
